export default "__VITE_ASSET__LO$ERFBM__"